import { SubscriptionInvoicesList } from '@components'

import { ModuleLayout } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../enums/queryKeys'
import { fetchUmbrellaInvoices } from '../../../../query-api/subscription-invoices-query'

interface UmbrellaInvoicesProps {
  umbrellaId: string
}

export const UmbrellaInvoices = ({ umbrellaId }: UmbrellaInvoicesProps): ReactElement => {
  const { t } = useTranslation()

  const { data: invoicesData, isLoading: isLoadingInvoices } = useQuery([QueryKeys.UmbrellaInvoices, umbrellaId], () =>
    fetchUmbrellaInvoices(umbrellaId),
  )

  return (
    <ModuleLayout title={t('umbrella_invoices.title')}>
      <SubscriptionInvoicesList invoices={invoicesData?.data} isLoading={isLoadingInvoices} />
    </ModuleLayout>
  )
}
